import React from 'react';
import {Divider, Grid, ListItemText, Typography} from "@mui/material";
import {toPriceWithComma} from "../../../helper/utils";

const _LiCreditIncome = (credit) => {
    return (
        <>

        </>
    );
};

export default _LiCreditIncome;
